/***
 *
 *   IMAGE
 *   Image wrapper
 *   Import the image before passing it to this component's source prop
 *
 *   PROPS
 *   alt: alt description (string, required)
 *   className: custom styling (SCSS or tailwind style, optional)
 *   source: imported source (image, required)
 *   title: description (string, required)
 *
 **********/

import { ClassHelper } from '../../utils/className';
import { ImageProps } from './types';

export const Image = (props: ImageProps) => {
  const imageStyle = ClassHelper({ base: 'max-w-full' }, props);

  return (
    <img
      src={props.source}
      alt={props.alt}
      title={props.title}
      className={imageStyle}
    />
  );
};
